import React from "react";
import * as Tone from "tone";

//components
import Grid from "@mui/material/Grid";
import LeftContainer from "components/LeftContainer";
import RightContainer from "components/RightContainer";
import MiddleContainer from "components/MiddleContainer";
import SwipeableViews from "components/shared/SwipableViews/SwipeableViews";
//assets
import tempoIndicator from "assets/phase2/tempo.png";
import transposeIndicator from "assets/phase2/transpose.png";
import volumeIndicator from "assets/phase2/volume.png";
import leftBack from "assets/phase7/Left.jpg";
import middleBack from "assets/phase7/Middle.jpg";
import rightBack from "assets/phase7/Right.jpg";

const styles = {
  LeftPortraitContainer: {
    position: "relative",
    right: "0px",
    bottom: "0px",
    width: "100%",
    height: "100%",
    backgroundImage: `url(${leftBack})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right bottom",
    overflow: "hidden",
  },
  MiddlePortraitContainer: {
    width: "100%",
    height: "100%",
    backgroundImage: `url(${middleBack})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom",
    paddingTop: "67%",
    paddingBottom: "10%",
    overflow: "hidden",
  },
  RightProtraitContainer: {
    width: "100%",
    height: "100%",
    backgroundImage: `url(${rightBack})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left bottom",
    paddingTop: "67%",
    paddingBottom: "6%",
    overflow: "hidden",
  },
};
class Base extends React.Component {
  trackStates = {
    vocal: "",
    inst: "",
    drums: "",
    BV: "",
  };

  constructor(props) {
    super(props);

    this.audioContextInstance = props.audioContextInstance;
    Tone.setContext(props.audioContextInstance);

    this.pitchShifterNode = new Tone.PitchShift();

    this.timestamps = [];
    this.tempos = [];
    this.repeats = Array(this.timestamps.length).fill(1);
    this.setRepeats = (index, value) => {
      this.repeats[index] = value;
      this.forceUpdate();
    };

    this.keyboardRef = React.createRef();
    this.rightContainerRef = React.createRef();
    this.masterGainNode = this.audioContextInstance.createGain();

    this.compressor = this.audioContextInstance.createDynamicsCompressor();
    this.compressor.threshold.setValueAtTime(
      -50,
      this.audioContextInstance.currentTime
    );
    this.compressor.knee.setValueAtTime(
      40,
      this.audioContextInstance.currentTime
    );
    this.compressor.ratio.setValueAtTime(
      12,
      this.audioContextInstance.currentTime
    );
    this.compressor.attack.setValueAtTime(
      0,
      this.audioContextInstance.currentTime
    );
    this.compressor.release.setValueAtTime(
      0.25,
      this.audioContextInstance.currentTime
    );

    this.mergerNode = this.audioContextInstance.createChannelMerger(5);

    this.trackStates = {
      vocal: "",
      inst: "",
      drums: "",
      BV: "",
    };

    this.state = {
      rightContainerRef: React.createRef(),
      keyboardRef: React.createRef(),
      currentTrack: 1,
      frequency: "",
      password: "",
      selectedLetter: "",
      currentTypingFocus: "frequency",
      currentTime: 0,
      leftIndicatorState: "onTempo",
      masterVolume: 100,
      lastMasterVolume: 100,
      masterVolumeKnobValue: 0,
      tempoKnobValue: 0,
      transposeKnobValue: 0,
      containersHeight: 0,
      leftIndicatorBackgrounds: {
        onTempo: tempoIndicator,
        onTranspose: transposeIndicator,
        onVolume: volumeIndicator,
      },
      playState: "stopped",
      playbackSpeed: 1,
      tempo: 120,
      transpose: 0,
      currentPortion: 0,
      tempoRotateDirection: 0,
      stopPropagate: false,
      activeTab: 2,
    };
  }

  percentOfHeight = (percent) => {
    if (isNaN(this?.state?.containersHeight)) return "";
    return `${Math.floor(this?.state?.containersHeight * (percent / 100))}px`;
  };

  percentOfWidth = (percent) => {
    if (isNaN(this.rightContainerRef?.current?.offsetWidth)) return "";
    return `${
      Math.floor(
        this.rightContainerRef?.current?.offsetWidth * (percent / 100)
      ) || 0
    }px`;
  };

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  setCurrentTime = (time) => {
    this.setState({ currentTime: time });
  };
  
  setTimestamps = (timestamps) => {
    this.timestamps = [...timestamps];
    this.repeats = Array(timestamps.length).fill(1);
    this.forceUpdate();
  };
  setTempos = (tempos) =>{
    this.tempos = tempos;
    this.forceUpdate();
  }

  setDefaultTempo = (defaultTempo) =>{
    this.defaultTempo = defaultTempo;
    this.forceUpdate();
  }

  handelTempoChange = (rotateDirection) => {
    const newValue = Math.max(
      60,
      Math.min(240, this?.state?.tempo + rotateDirection)
    );
    const ratio = newValue / (this?.state?.defaultTempo + 0.0);
    this.setState((prevState) => ({
      tempo: Math.max(60, Math.min(240, prevState.tempo + rotateDirection)),
      playbackSpeed: ratio,
    }));
  };
  setTempoValue = (newValue) => {
    this.setState({ tempo: newValue, playbackSpeed: 1 });
  };
  resetTranspose   = () =>{
    this.setState({transpose:0})
    this.pitchShifterNode.pitch = 0;
  }

  handelTransposeChange = (rotateDirection) => {
    this.setState((prevState) => ({
      transpose: Math.max(
        -12,
        Math.min(12, prevState.transpose + rotateDirection)
      ),
    }));
    this.pitchShifterNode.pitch = Math.round(this.state.transpose);
  };

  handelVolumeChange = (value) => {
    let rotateDirection = this?.state?.masterVolumeKnobValue > value ? -1 : 1;
    this.setState((prevState) => ({
      masterVolumeKnobValue: value,
      masterVolume: Math.max(
        0,
        Math.min(100, prevState.masterVolume + (rotateDirection * value) / 50)
      ),
    }));
  };

  handelPlay = () => {
    this.setState({ playState: "played", stopPropagate: false });
  };

  handelPause = () => {
    this.setState({ playState: "paused", stopPropagate: false });
  };

  setPlayState = (state, stopPropagate) => {
    this.setState({ playState: state, stopPropagate: stopPropagate });
  };

  bringBackTheMasterVolume = () => {
    this.setState({
      masterVolume: this.state.lastMasterVolume,
    });
  };

  changeCurrentTimeByUser = (time) => {
    this.setState((lastState) => ({
      playState: "seeked",
      stopPropagate: false,
      currentTime: time,
      lastMasterVolume: lastState.masterVolume,
      masterVolume: 0,
    }));
  };

  announceCurrentPortion = (currentPortion) => {
    if (currentPortion >= 1) return;
    this.setState({ currentPortion: currentPortion });
  };

  handelNextTrack = () => {
    this.setState((prevState) => ({
      currentTrack: prevState.currentTrack + 1,
    }));
  };
  handelPrevTrack = () => {
    this.setState((prevState) => ({
      currentTrack: prevState.currentTrack - 1,
    }));
  };

  componentWillReceiveProps(nextProps) {}

  componentDidMount() {
    Tone.connect(this.masterGainNode, this.pitchShifterNode);
    this.pitchShifterNode.pitch = this.state.transpose;
    Tone.connect(this.pitchShifterNode, this.compressor);

    this.compressor.connect(this.audioContextInstance.destination);

    this.masterGainNode.gain.setValueAtTime(
      this?.state?.masterVolume / 100 || 1,
      this.audioContextInstance.currentTime
    );
    if (this.rightContainerRef?.current?.offsetWidth) {
      this.setState({
        containersHeight: Math.floor(
          (this?.rightContainerRef?.current?.offsetWidth / 16) * 9 * 3
        ),
      });
    }

    let ct = this.timestamps.findIndex((t) => t > this?.state?.currentTime);
    if (this?.state?.currentTrack !== ct) {
      this.setState({ currentTrack: ct });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.masterVolume !== this?.state?.masterVolume) {
      this.masterGainNode.gain.setValueAtTime(
        this?.state?.masterVolume / 100,
        this.audioContextInstance.currentTime
      );
    }

    if (prevState.currentTime !== this?.state?.currentTime) {
      let ct = this.timestamps.findIndex((t) => t > this?.state?.currentTime);
      if (this?.state?.currentTrack !== ct) {
        this.setState({ currentTrack: ct });
      }
    }
  }

  render() {
    return (
      <>
        <div style={styles.root}>
          <SwipeableViews
            index={this.state.activeTab}
            onChangeIndex={this.setActiveTab}
            style={{ height: `${this.state.containersHeight}px` }}
            containerStyle={{ height: `${this.state.containersHeight}px` }}
            enableMouseEvents
            resistance={true}
            animateTransitions={true}
          >
            <Grid
              container
              style={{
                ...styles.LeftPortraitContainer,
                height: `${this?.state?.containersHeight}px`,
                paddingTop: this.percentOfHeight(12),
                paddingBottom: this.percentOfHeight(4.5),
              }}
            >
              <LeftContainer
                percentOfHeight={this.percentOfHeight}
                percentOfWidth={this.percentOfWidth}
                repeats={this.repeats}
                setRepeats={this.setRepeats}
                currentTime={this.state.currentTime}
                timestamps={this.timestamps}
                defaultTempos={this.tempos}
                currentTrack={this.state.currentTrack}
                changeCurrentTimeByUser={this.changeCurrentTimeByUser}
                handelVolumeChange={this.handelVolumeChange}
                handelTempoChange={this.handelTempoChange}
                setTempoValue={this.setTempoValue}
                resetTranspose={this.resetTranspose}
                handelTransposeChange={this.handelTransposeChange}
                handelNextTrack={this.handelNextTrack}
                handelPrevTrack={this.handelPrevTrack}
                handelPause={this.handelPause}
                handelPlay={this.handelPlay}
                containersHeight={this.state.containersHeight}
                tempo={this.state.tempo}
                transpose={this.state.transpose}
                masterVolume={this.state.masterVolume}
                playState={this.state.playState}
              />
            </Grid>

            <Grid
              container
              direction="column"
              style={{
                ...styles.MiddlePortraitContainer,
                height: `${this?.state?.containersHeight}px`,
                paddingTop: `${this?.state?.containersHeight * 0.12}px`,
                paddingBottom: `${this?.state?.containersHeight * 0.06}px`,
              }}
            >
              <MiddleContainer
                stopPropagate={this.state.stopPropagate}
                setTimestamps={this.setTimestamps}
                defaultTempos={this.tempos}
                bringBackTheMasterVolume={this.bringBackTheMasterVolume}
                setPlayState={this.setPlayState}
                playState={this.state.playState}
                tempoRotateDirection={this.state.tempoRotateDirection}
                percentOfHeight={this.percentOfHeight}
                percentOfWidth={this.percentOfWidth}
                currentTime={this.state.currentTime}
                portrait={true}
                currentTrack={this.state.currentTrack}
                audioContextInstance={this.audioContextInstance}
                mergerNode={this.mergerNode}
                playbackSpeed={this.state.playbackSpeed}
                webAudioOutput={this.masterGainNode}
                layers={this.state.layers}
                changeState={this.changeState}
                setCurrentTime={this.setCurrentTime}
                announceCurrentPortion={this.announceCurrentPortion}
                tempo={this.state.tempo}
              />
            </Grid>

            <Grid
              container
              ref={this.rightContainerRef}
              style={{
                ...styles.RightProtraitContainer,
                height: `${this?.state?.containersHeight}px`,
                paddingTop: this.percentOfHeight(12),
                paddingBottom: this.percentOfHeight(6),
              }}
            >
              {/* <LoginModal /> */}
              <RightContainer
                percentOfHeight={this.percentOfHeight}
                percentOfWidth={this.percentOfWidth}
                containersHeight={this.state.containersHeight}
                setActiveTab={this.setActiveTab}
              />
            </Grid>
          </SwipeableViews>
        </div>
      </>
    );
  }
}

export default Base;
